import React, { createContext } from 'react';
import http from '../utils/httpFacade';

export const ProductContext = createContext();

const ProductContextProvider = ({ children }) => {
  const getProduct = async query => {
    try {
      return await http.get({ url: 'crowd-farmer/products', query });
    } catch (error) {
      return error.data;
    }
  };

  const getProducts = async query => {
    try {
      return await http.get({ url: 'products', query });
    } catch (error) {
      return error.data;
    }
  };

  return (
    <ProductContext.Provider value={{ getProduct, getProducts }}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductContextProvider;
